/**
 * 休眠
 * @type {function(*): Promise<unknown>}
 */
module.exports.delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}